/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Resource and Data Exchange
 * Resource Explorer Service API
 * OpenAPI spec version: 0.1.0
 */
import type {HttpContext, HttpEvent, HttpParams} from '@angular/common/http';
import {HttpResponse as AngularHttpResponse, HttpClient, HttpHeaders} from '@angular/common/http';

import {Injectable, inject} from '@angular/core';

import {Observable} from 'rxjs';

import {APP_ENVIRONMENT} from '@app/core/tokens/app-environment.token';
import {type AppEnvironment} from '@models/environment';

import type {OrganizationCreate, OrganizationListResponse, OrganizationPatch, OrganizationResponse} from '../../models';

interface HttpClientOptions {
  readonly headers?: HttpHeaders | Record<string, string | string[]>;
  readonly context?: HttpContext;
  readonly params?: HttpParams | Record<string, string | number | boolean | Array<string | number | boolean>>;
  readonly reportProgress?: boolean;
  readonly withCredentials?: boolean;
  readonly credentials?: RequestCredentials;
  readonly keepalive?: boolean;
  readonly priority?: RequestPriority;
  readonly cache?: RequestCache;
  readonly mode?: RequestMode;
  readonly redirect?: RequestRedirect;
  readonly referrer?: string;
  readonly integrity?: string;
  readonly referrerPolicy?: ReferrerPolicy;
  readonly transferCache?: {includeHeaders?: string[]} | boolean;
  readonly timeout?: number;
}

type HttpClientBodyOptions = HttpClientOptions & {
  readonly observe?: 'body';
};

type HttpClientEventOptions = HttpClientOptions & {
  readonly observe: 'events';
};

type HttpClientResponseOptions = HttpClientOptions & {
  readonly observe: 'response';
};

type HttpClientObserveOptions = HttpClientOptions & {
  readonly observe?: 'body' | 'events' | 'response';
};

@Injectable({providedIn: 'root'})
export class OrganizationService {
  public http = inject(HttpClient);
  _environment: AppEnvironment = inject(APP_ENVIRONMENT);
  _baseUrl: string | undefined = undefined;

  get baseUrl(): string {
    return this._baseUrl ?? this._environment.api;
  }

  set baseUrl(newUrl: string) {
    this._baseUrl = newUrl;
  }

  /**
   * Get list of organizations
   * @summary Get Organizations
   */
  getOrganizations<TData = OrganizationListResponse>(options?: HttpClientBodyOptions): Observable<TData>;
  getOrganizations<TData = OrganizationListResponse>(options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
  getOrganizations<TData = OrganizationListResponse>(
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  getOrganizations<TData = OrganizationListResponse>(
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(`${this.baseUrl}/api/organizations`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(`${this.baseUrl}/api/organizations`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.get<TData>(`${this.baseUrl}/api/organizations`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }
  /**
   * Creates a new organization
   * @summary Create Organization
   */
  createOrganization<TData = unknown | void>(
    organizationCreate: OrganizationCreate,
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  createOrganization<TData = unknown | void>(
    organizationCreate: OrganizationCreate,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  createOrganization<TData = unknown | void>(
    organizationCreate: OrganizationCreate,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  createOrganization<TData = unknown | void>(
    organizationCreate: OrganizationCreate,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(`${this.baseUrl}/api/organizations`, organizationCreate, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(`${this.baseUrl}/api/organizations`, organizationCreate, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.post<TData>(`${this.baseUrl}/api/organizations`, organizationCreate, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }
  /**
   * Gets data for organization
   * @summary Get Organization
   */
  getOrganization<TData = OrganizationResponse>(
    organizationName: string,
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  getOrganization<TData = OrganizationResponse>(
    organizationName: string,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  getOrganization<TData = OrganizationResponse>(
    organizationName: string,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  getOrganization<TData = OrganizationResponse>(
    organizationName: string,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(`${this.baseUrl}/api/organizations/${organizationName}`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(`${this.baseUrl}/api/organizations/${organizationName}`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.get<TData>(`${this.baseUrl}/api/organizations/${organizationName}`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }
  /**
   * Patches an existing organization. This endpoint allows updates by sending a single field to update in the request
   * body.
   * @summary Patch Organization
   */
  patchOrganization<TData = unknown | void>(
    organizationName: string,
    organizationPatch: OrganizationPatch,
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  patchOrganization<TData = unknown | void>(
    organizationName: string,
    organizationPatch: OrganizationPatch,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  patchOrganization<TData = unknown | void>(
    organizationName: string,
    organizationPatch: OrganizationPatch,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  patchOrganization<TData = unknown | void>(
    organizationName: string,
    organizationPatch: OrganizationPatch,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.patch<TData>(`${this.baseUrl}/api/organizations/${organizationName}`, organizationPatch, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.patch<TData>(`${this.baseUrl}/api/organizations/${organizationName}`, organizationPatch, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.patch<TData>(`${this.baseUrl}/api/organizations/${organizationName}`, organizationPatch, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }
  /**
   * Updates an existing organization
   * @summary Update Organization
   */
  updateOrganization<TData = unknown | void>(
    organizationName: string,
    organizationCreate: OrganizationCreate,
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  updateOrganization<TData = unknown | void>(
    organizationName: string,
    organizationCreate: OrganizationCreate,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  updateOrganization<TData = unknown | void>(
    organizationName: string,
    organizationCreate: OrganizationCreate,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  updateOrganization<TData = unknown | void>(
    organizationName: string,
    organizationCreate: OrganizationCreate,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.put<TData>(`${this.baseUrl}/api/organizations/${organizationName}`, organizationCreate, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.put<TData>(`${this.baseUrl}/api/organizations/${organizationName}`, organizationCreate, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.put<TData>(`${this.baseUrl}/api/organizations/${organizationName}`, organizationCreate, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }
}
